import React from "react";

import logo from "../../assets/images/prom-opecs-logo.png";
import ContactInfo from "./ContactInfo";
import LanguageSwitch from "./LanguageSwitch";

const TopBar = ({ onLangChange }) => {
    return (
        <section className="prom__layout--header_top-bar">
            <div className="top-bar__logo">
                <img src={logo} alt={"Prom-opecs logo"} />
            </div>
            <div className="top-bar__address">
                <ContactInfo />
                <LanguageSwitch onLangChange={onLangChange} />
            </div>
        </section>
    )
};

export default TopBar
